module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-header"
  }, [_c('div', {
    staticClass: "ushk-header__box"
  }, [_c('div', {
    staticClass: "ushk-wrap ushk-wrap-main"
  }, [_c('div', {
    staticClass: "ushk-header__wrap"
  }, [_vm._m(0), _vm._v(" "), (!_vm.isPcFlag) ? _c('div', {
    staticClass: "ushk-header__r"
  }, [_c('div', {
    class: ['ushk-header__btn', {
      'ushk-header__close': _vm.showNav
    }],
    on: {
      "click": _vm.switchNav
    }
  }, [_c('span')]), _vm._v(" "), _vm._l((_vm.menus), function(menu) {
    return (_vm.setActiveState(menu.type)) ? _c('div', {
      staticClass: "ushk-header__act"
    }, [_vm._v("\n            " + _vm._s(menu.name) + "\n          ")]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.showDesc) ? _c('div', {
    staticClass: "ushk-header__f"
  }, [_vm._v("投资，快人一步")]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showNav) ? _c('div', {
    staticClass: "ushk-header__b"
  }, [_c('ul', {
    staticClass: "ushk-header-nav"
  }, _vm._l((_vm.menus), function(menu) {
    return _c('li', {
      staticClass: "ushk-header-nav__item",
      class: [
        ("ushk-header-nav__" + (menu.type)),
        {
          'is-active': _vm.setActiveState(menu.type)
        } ]
    }, [_c('a', {
      attrs: {
        "href": menu.url
      }
    }, [_c('span', [_vm._v(_vm._s(menu.name))])])])
  }), 0)]) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "ushk-header__slot"
  }, [_vm._t("default")], 2)])]), _vm._v(" "), (_vm.showNav && !_vm.isPcFlag) ? _c('div', {
    staticClass: "ushk-header__fixbg",
    on: {
      "click": _vm.switchNav
    }
  }) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ushk-header__h"
  }, [_c('a', {
    attrs: {
      "href": "//www.ushknews.com"
    }
  }, [_c('h1', {
    staticClass: "ushk-header__logo"
  }, [_vm._v("美港电讯")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cddac0e","hasScoped":false,"transformToRequire":{"img":["src","srcset"]}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = d1Y1
// module chunks = 2